import { Reveal, MaskLineInView } from "../motion/Reveal";

export const Overline = ({ children, className = "" }) => (
  <div className={`flex items-center gap-3 ${className}`}>
    <span className="h-px w-8 bg-[#e60000]" />
    <span className="overline">{children}</span>
  </div>
);

export const SectionHeading = ({ overline, title, sub, align = "left", className = "" }) => (
  <div className={`${align === "center" ? "text-center items-center" : ""} flex flex-col ${className}`}>
    {overline && (
      <div className={align === "center" ? "mx-auto" : ""}>
        <Overline>{overline}</Overline>
      </div>
    )}
    <h2 data-pg-label className="mt-6 font-display font-black tracking-tightest leading-[0.95] text-4xl sm:text-5xl lg:text-6xl text-white max-w-4xl">
      <MaskLineInView>{title}</MaskLineInView>
    </h2>
    {sub && (
      <Reveal delay={0.15}>
        <p className={`mt-6 text-regera-dim text-base sm:text-lg leading-relaxed max-w-2xl ${align === "center" ? "mx-auto" : ""}`}>
          {sub}
        </p>
      </Reveal>
    )}
  </div>
);

export const PageHero = ({ overline, title, sub, image }) => (
  <section className="relative pt-28 lg:pt-32 pb-10 lg:pb-12 overflow-hidden">
    {image && (
      <div className="absolute inset-0 z-0">
        <img src={image} alt="" className="h-full w-full object-cover opacity-25 grayscale" />
        <div className="absolute inset-0 bg-gradient-to-b from-[#0a0a0a]/70 via-[#0a0a0a]/60 to-[#0a0a0a]" />
      </div>
    )}
    <div className="relative z-10 mx-auto max-w-[1600px] px-5 sm:px-8 lg:px-12">
      {overline && <Overline>{overline}</Overline>}
      <h1 className="mt-5 font-display font-black tracking-tight leading-[1.04] text-4xl sm:text-5xl xl:text-6xl text-white max-w-5xl">
        <MaskLineInView>{title}</MaskLineInView>
      </h1>
      {sub && (
        <Reveal delay={0.2}>
          <p className="mt-8 text-regera-dim text-lg lg:text-xl leading-relaxed max-w-2xl">{sub}</p>
        </Reveal>
      )}
    </div>
  </section>
);

export default SectionHeading;
